import { UserProfileModel } from '../../../shared/stores/models/UserProfileModel';

import { DEFAULT } from '../../constants/ProductPricingTypes';
import {
  DefaultProductConfigDTO,
  ProductResponseTypesDTO
} from '../../stores/dtos/product.dtos';
import DefaultProduct from '../../stores/models/ProductModels/DefaultProduct';

export const getProductFromPricingType = (
  productObject: ProductResponseTypesDTO,
  userProfileDetails: UserProfileModel | null = null
) => {
  const { pricingType } = productObject.productDetails;

  if (pricingType === DEFAULT) {
    return new DefaultProduct(
      productObject as DefaultProductConfigDTO,
      userProfileDetails
    );
  } else {
    throw Error(`pricing_type ${pricingType} is not valid `);
  }
};
